import React, { Component } from 'react'
import { SHr, SImage, SNavigation, SNotification, SText, STheme, SView } from 'servisofts-component2';
import { TopBarPropsType } from '..';
import BackArrow from "../../../Assets/backArrow.svg"
import Menu from "../../../Assets/menu.svg"
import MDL from '../../../MDL';
import BarraRastreo from '../../../Components/BarraRastreo';
import NavBar from '../../NavBar';

export default class home extends Component<TopBarPropsType> {

    constructor(props: TopBarPropsType) {
        super(props);
        this.state = {
            checklistTractoraFaltante: false,
            checklistRemolqueFaltante: false,
        };
    }

    componentDidMount() {
        // this.verificarChecklist();
    }

    verificarChecklist = async () => {
        let checklistTractoraFaltante = false;
        let checklistRemolqueFaltante = false;
        try {
            const dni = MDL.usuario?.session?.sDNI;
            const matricula = MDL.usuario?.session?.plate;
            const expediciones = MDL.usuario?.session?.expediciones;
            if (!dni || !matricula) {
                SNotification.send({
                    key: "sin_datos",
                    title: "Error",
                    body: "Faltan datos de usuario.",
                    color: "#dc2626",
                    time: 3000,
                });
                SNavigation.navigate('/login');
                return;
            }

            const responseTractora = await MDL.checklist.getChecklistRegistros(dni, matricula);
            if (!responseTractora) {
                checklistTractoraFaltante = true;
            } else {
                SNotification.send({
                    key: "sin_checklist_tractora",
                    title: "Tractora Checklist",
                    body: "Tractora con checklist completado.",
                    color: "#37d906",
                    time: 3000,
                });
            }

            if (Array.isArray(expediciones)) {
                for (const exp of expediciones) {
                    const sRemolque = String(exp?.sRemolque ?? "").trim();
                    const responseRemolque = await MDL.checklist.getChecklistRegistros(dni, sRemolque);
                    if (!responseRemolque) {
                        checklistRemolqueFaltante = true;
                    } else {
                        SNotification.send({
                            key: `checklist_remolque_${sRemolque}`,
                            title: "Checklist",
                            body: `Checklist del remolque ${sRemolque} completado.`,
                            color: "#37d906",
                            time: 3000,
                        });
                    }
                }
            }
            this.setState({ checklistTractoraFaltante, checklistRemolqueFaltante, });
        } catch (error: any) {
            const { checklistTractoraFaltante: tractora, checklistRemolqueFaltante: remolque } = this.state;
            SNotification.send({
                key: "error_checklist",
                title: tractora ? "Pendiente Checklist Tractora" : "Pendiente Checklist Remolque",
                body: tractora ? "Debes completar el checklist de la tractora" : "Debes completar el checklist del remolque",
                color: "#d97706",
                time: 3000,
            });
            console.warn("Error en verificación de checklist:", error);
            SNavigation.navigate('/check/MessageInfo');
        }
    }

    getBack() {
        if (this.props.preventBack) {
            return null;
        }
        return (
            <SView col={"xs-12"} height center>
                <SView
                    onPress={() => {
                        if (this.props.onBack) {
                            const prevent_default = this.props.onBack();
                            if (prevent_default) return;
                        }
                        SNavigation.goBack();
                    }}
                    col={"xs-12"}
                    style={{ paddingBottom: 4 }}
                    center
                    height
                >
                    <BackArrow height={18} fill={STheme.color.text} />
                </SView>
            </SView>
        );
    }
    render() {
        const H = 60;
        return (
            <SView col={"xs-12"} height={60} backgroundColor={STheme.color.barColor} center row>
                <SView col={"xs-11"} row height>
                    <SView width={70} height>
                        <SImage src={require("../../../Assets/img/logogamarillo.png")} />
                    </SView>
                    <SView flex height center style={{ justifyContent: "flex-end" }}>
                        <BarraRastreo />
                        <SHr h={4} />
                    </SView>
                    <SView width={H} height={H} onPress={() => NavBar.open()} center>
                        <Menu name={'Menu'} height={23} fill={STheme.color.text} />
                    </SView>
                </SView>
            </SView>
        );
    }
}